import React from 'react'
import { createRoot } from 'react-dom/client'
import PropTypes from 'prop-types'

import { Button3d } from 'components/Buttons'
import SimpleModal from './SimpleModal'

export default class ConfirmModal extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    type: PropTypes.string.isRequired,
    confirmLabel: PropTypes.string,
    confirmColor: PropTypes.string,
    onConfirm: PropTypes.func,
    denyLabel: PropTypes.string,
    denyColor: PropTypes.string,
    onDeny: PropTypes.func,
    showCancel: PropTypes.bool,
    cancelLabel: PropTypes.string,
    cancelColor: PropTypes.string,
    onCancel: PropTypes.func,
    onHide: PropTypes.func
  }

  static defaultProps = {
    confirmLabel: "Confirm",
    confirmColor: "red",
    denyLabel: "Cancel",
    denyColor: "blue",
    showCancel: false,
    cancelLabel: "Cancel",
    cancelColor: "gray",
  }

  state = { show: true }

  hide = () => {
    this.setState({ show: false })
    this.props.onHide?.()
  }

  onConfirm = () => {
    this.props.onConfirm?.()
    this.hide()
  }

  onDeny = () => {
    this.props.onDeny?.()
    this.hide()
  }

  onCancel = () => {
    this.props.onCancel?.()
    this.hide()
  }

  renderConfirmFooter() {
    return <>
      {/* confirm button */}
      <Button3d { ...{[this.props.confirmColor]: true }} action={ this.onConfirm }>{ this.props.confirmLabel }</Button3d>

      {/* deny button */}
      <Button3d { ...{[this.props.denyColor]: true }} action={ this.onDeny }>{ this.props.denyLabel }</Button3d>

      {/* cancel button (optional) */}
      { this.props.showCancel &&
        <Button3d { ...{[this.props.cancelColor]: true }} action={ this.onCancel }>{ this.props.cancelLabel }</Button3d>
      }
    </>
  }

  renderFooter() {
    return this.props.type === 'alert'
      ? <Button3d action={ this.hide }>Close</Button3d>
      : this.props.type === 'confirm'
        ? this.renderConfirmFooter()
        : null
  }

  render() {
    return (
      <SimpleModal
        id='confirmation-modal'
        title={ this.props.title }
        show={ this.state.show }
        onHide={ this.hide }
        footer={ this.renderFooter() }
      >
        <div className='section'>
          { this.props.children }
        </div>
      </SimpleModal>
    )
  }
}

export const popoverAlert = (options) => {
  options = {
    // Defaults
    title: "Alert",
    type: 'alert',
    // Given
    ...options
  }

  const message = options.message
  delete options.message

  renderModal(message, options)
}

export const confirmation = (options={}) => {
  // Must specify what to do upon confirmation
  if(!options.onConfirm) { throw new Error("Must pass onConfirm callback to confirmation()") }

  options = {
    // Defaults
    title: "Warning",
    type: 'confirm',
    // Given
    ...options
  }

  const message = options.message || "Are you sure?"
  delete options.message

  renderModal(message, options)
}

const renderModal = (message, options) => {
  const
    // Where in DOM to mount
    wrapper = document.body.appendChild(document.createElement('div')),
    root = createRoot(wrapper),
    // Clean DOM after closed
    removeWrapper = () => {
      setTimeout(() => {
        root.unmount()
        if (document.body.contains(wrapper)) {
          document.body.removeChild(wrapper)
        }
      }, 600)
    }

  // Mount it!
  root.render(
    <ConfirmModal { ...options } onHide={ removeWrapper }>
      { message }
    </ConfirmModal>
  )
}
